<ejs-toast #toasttype id='toasttype' (beforeOpen)="onBeforeOpen($event)" (close)="close($event)" [position]="position">
</ejs-toast>
<div class="prelogin-outer-bg">
  <div class="e-h-100vh d-flex align-items-center row">
    <app-spinner></app-spinner>
    <div class="col e-pre-login-form-box e-py-4" id="e-pre-login-form-box">
      <div class="bg-white align-items-center e-panel-user-form e-pre-login-form-inner-box">
        <div class="e-panel-user-form-box e-py-5 e-px-7">
          <div class="e-mb-4 e-text-center">
            <img src="/assets/images/syntrio-logo-blue.png" alt="Mitratech Logo" height="44px">
          </div>

          <h4 class="e-mb-4 font-weight-bold e-text-center user-form-heading">Create Incident Report PIN</h4>
          <form [formGroup]="pinForm" #form="ngForm" class="">
            <div class="row">
              <div class="col-12 e-form-group e-mb-4">
                <ejs-textbox cssClass="e-autofill e-mandetory e-outline" [required]="true"
                  placeholder="Email Address" floatLabelType="Always" formControlName="UserName"
                autocomplete="off"></ejs-textbox>
                @if (submitted && formControl.UserName.errors && formControl.UserName.errors.required) {
                  <div class="validation-error-box"
                    >
                    User Name is required
                  </div>
                }
                @if (submitted && pinForm.hasError('email', 'UserName')) {
                  <div
                    class="validation-error-box">
                    Please enter valid Email
                  </div>
                }
              </div>
              <div class="col-12 e-form-group e-mb-4">
                <ejs-textbox cssClass="e-mandetory e-outline" placeholder="Case Number"
                floatLabelType="Always" formControlName="CaseNumber"></ejs-textbox>
                @if (submitted && formControl.CaseNumber.errors) {
                  <div class="validation-error-box">
                    Case Number is required
                  </div>
                }
              </div>
              <div class="col-12 e-form-group e-mb-4">
                <ejs-textbox placeholder="Enter a New PIN" cssClass="e-mandetory e-outline"
                  [required]="true" type="password" formControlName="NewPin" floatLabelType="Always">
                </ejs-textbox>
                @if (submitted && formControl.NewPin.errors && formControl.NewPin.errors.required) {
                  <div
                    class="validation-error-box">
                    New PIN is required
                  </div>
                }
                @if (formControl.NewPin.errors && formControl.NewPin.errors.minlength) {
                  <div
                    class="validation-error-box">
                    New PIN must be at least {{caseNoMinPinLength}} characters long
                  </div>
                }
              </div>
              <div class="col-12 e-form-group e-mb-3">
                <ejs-textbox placeholder="Confirm Sign in PIN" cssClass="e-mandetory e-outline"
                  [required]="true" floatLabelType="Always" type="password"
                formControlName="ConfirmPin"></ejs-textbox>
                @if (submitted && formControl.ConfirmPin.errors && formControl.ConfirmPin.errors.required) {
                  <div
                    class="validation-error-box">
                    Confirm PIN is required
                  </div>
                }
                @if (submitted && pinForm.hasError('notSame')) {
                  <div class="validation-error-box">
                    New PINs entered do not match
                  </div>
                }
              </div>
            </div>
            <div class="e-password-policy-list">
              <ul class="custom-list unordered-list e-my-0">
                @for (note of respondCreatePinNotes; track note) {
                  <li>
                    {{note}}
                  </li>
                }
              </ul>
            </div>
            <div class="row">
              <div class="col-12 e-mt-3">
                <button ejs-button (click)="onSubmit()"
                  cssClass="e-primary e-block e-bigger e-btn font-weight-bold e-css e-control e-lib">
                  Create PIN
                </button>
                <div class="e-text-center e-mt-4">
                  <a class="e-pointer e-text-underline font-weight-bold" (click)="GoToRespond()">
                    Back to Respond Login
                  </a>
                </div>
              </div>
            </div>
          </form>

        </div>
      </div>
      <app-footer [includeLinks]="true"></app-footer>
    </div>
  </div>
</div>